// extracted by mini-css-extract-plugin
export default {"title":"_1dJvdZ80HxiBajhDT48QPl","grid":"SLf-4VWtbRwiAn4jVJ3o5","carousel":"SaJ82z9maxW2hEWt0nVHC","amenityAlignment":"_20obyJFHEtB3BMlBK5CEJH"};